import React, { useEffect, useState } from "react";
import Menusidebar from "../components/Element/Menusidebar";
import { Redirect } from "react-router-dom";
//import Profilesidebar from '../components/Element/Profilesidebar';
// import MyAssignements from "../components/Element/MyAssignments";
import AccountCentreSidebar from "../components/Element/AccountCentreSidebar";
import { isMobileOrLaptop } from "../services/CheckDevice";
import MenuSideBarMobile from "../components/Element/MenuSideBarMobile";
import ShiftAttendanceDetails from "../components/Element/ShiftAttendance/ShiftAttendanceDetails";
import { redirectUrl } from "../services/GlobalUrls";
const ShiftAttendanceMain = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");
  let usersCategory = localStorage.getItem("users_category");
  const normalizedCategory = usersCategory?.trim().toLowerCase().replace(/_/g, " ");


  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {window.location.pathname == "/cancel-assignments" && (
                  <AccountCentreSidebar />
                )}
                {window.location.pathname != "/cancel-assignments" && (
                  <>
                    {checkDevice == "Mobile" ? (
                      <MenuSideBarMobile page="shift-attendance" />
                    ) : (
                      <Menusidebar page="shift-attendance" />
                    )}
                  </>
                )}

                {/*<div className="col-xl-9 col-lg-8 m-b30"> */}

                <div className="col-xl-9 col-lg-8 m-b30">
                    {normalizedCategory && (
                      <ShiftAttendanceDetails normalizedCategory={normalizedCategory} deviceInfo={checkDevice} />
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShiftAttendanceMain;
